import { Component, OnDestroy, Input } from '@angular/core';
import { LocationPublic } from '../../../../../globalTypes/account.types';
import { Subject, takeUntil } from 'rxjs';
import { accountFeature } from '../../../store/account.store';
import { Store } from '@ngrx/store';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'msh-location-warning',
  imports: [RouterLink, MatIconModule],
  template: `
 @if(availableLocations.length > 1){
    <div class="flex bg-copy/50 text-back gap-8 text-xs justify-between items-center max-w-screen-md mx-auto border rounded px-4 py-2 my-4">
      <mat-icon class="text-lg md:!block !hidden">info</mat-icon>
      <div>
        <div class=" text-sm">
          @if(isListing){
            Purchases of this listing will be paid to
          } @else {
            Purchases will be paid out from  
          }
        </div>
        <div class=" font-semibold  text-xs">
          {{currentLocation?.name}} ({{currentLocation?.owner?.displayName}})
        </div>
      </div>
      <div>
        <a class=" block p-2  text-xs rounded border " [routerLink]="['/account','manage']">Switch Location</a>
      </div>
      
    </div>
  }
  `,
  styles: ``,
})
export class LocationWarning implements OnDestroy {
  @Input('isListing') isListing = false;
  availableLocations: LocationPublic[] = [];
  currentLocation: LocationPublic | null = null;
  private destroy$ = new Subject<void>();
  constructor(
    private store: Store,
  ) {

        this.store.select(accountFeature.selectAccountState).pipe(takeUntil(this.destroy$)).subscribe(accountState=>{
          console.log({accountState})
          this.availableLocations = accountState.availableLocations || [];
          this.currentLocation = accountState.location || null;
        })
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
